import { render, staticRenderFns } from "./TableParameter.vue?vue&type=template&id=1bce346a&scoped=true&"
import script from "./TableParameter.vue?vue&type=script&lang=js&"
export * from "./TableParameter.vue?vue&type=script&lang=js&"
import style0 from "./TableParameter.vue?vue&type=style&index=0&id=1bce346a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce346a",
  null
  
)

export default component.exports